import { Button, Form, Input, Modal } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { useAuth } from 'AuthContext';
import React, { useEffect, useState } from 'react';
import { green } from '@ant-design/colors';
import API from 'API';
import { CheckCircleOutlined } from '@ant-design/icons';

export default function StudentSendFeedback({ openModelObj }) {
    const [open, setOpen] = useState(false);
    const [sending, setSending] = useState(false);
    const [done, setDone] = useState(false);
    const [form] = useForm();
    const { user } = useAuth();
    useEffect(()=>{
        openModelObj.setOpenFeedback = setOpen;
    },[openModelObj])
    return <Modal
        open={open}
        onCancel={()=>setOpen(false)}
        title="Đóng góp ý kiến"
        width={700}
        footer={[
            done ? null : <Button key="submit" type='primary' loading={sending} disabled={sending} onClick={()=>{
                form.submit();
            }}>
                Đóng góp
            </Button>,
            <Button key="cancel" onClick={()=>setOpen(false)}>
                Đóng
            </Button>
        ]}
    >
        {done ? 
        <div className='text-center' style={{ color: green[7] }}>
            <CheckCircleOutlined style={{ fontSize: 40 }} />
            <p style={{ fontSize: 17 }}>
                Cảm ơn bạn đã đóng góp ý kiến, ý kiến của bạn đã được gửi đi, chúng tôi sẽ xem xét và cải thiện trong tương lai!
            </p>
        </div>
        : <Form
            name="student-send-feedback"
            form={form}
            labelCol={{
                span: 6,
            }}
            wrapperCol={{
                span: 18,
            }}
            onFinish={(values)=>{
                if (sending) return;
                setSending(true);
                API.post("student-send-feedback/", values)
                .then(res=>{
                    setDone(true);
                })
                .catch(error=>{

                })
                .finally(()=>{
                    setSending(false);
                })
            }}
        >
            <Form.Item label="Họ và tên:">
                <Input value={`${user?.last_name.trim()} ${user?.first_name.trim()}`} disabled />
            </Form.Item>
            <Form.Item label="Ý kiến của bạn:" name="comment" rules={[{ required: true, message: "Vui lòng nhập ý kiến của bạn" }]}>
                <Input.TextArea style={{ height: 120 }} placeholder='Bạn có thể đóng góp ý kiến để cải thiện trải nghiệm hệ thống trang web!&#10;Hoặc đóng góp để cải thiện chất lượng các tính năng AI!' />
            </Form.Item>
        </Form>}
    </Modal>
}
